import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onReady", "embeddedContext", "children"];
import { useEffect } from 'react';
import UIEmbeddedComponent from 'ui-addon-iframeable/embed/UIEmbeddedComponent';
import { IframeableContextProvider } from '../context/IframeableContext';
import { removeConversationsWidgetWhenAvailable } from '../utils/conversationsWidget';
import { jsx as _jsx } from "react/jsx-runtime";
export function createEmbeddedIframeableContainer(embedOptions = {}) {
  function IframeableContainer(_ref) {
    let {
        onReady,
        embeddedContext,
        children
      } = _ref,
      passthruProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    useEffect(() => {
      onReady({
        data: {},
        receiveMessage: () => {}
      });
      // Remove conversations widget if present to prevent double loading
      removeConversationsWidgetWhenAvailable();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const iframeableContext = Object.assign({}, embeddedContext, {
      passthruProps: passthruProps
    });
    return /*#__PURE__*/_jsx(IframeableContextProvider, {
      iframeableContext: iframeableContext,
      children: children
    });
  }
  return UIEmbeddedComponent(IframeableContainer, embedOptions);
}